import { render, staticRenderFns } from "./CultureCardComponent.vue?vue&type=template&id=279458ba"
import script from "./CultureCardComponent.vue?vue&type=script&lang=js"
export * from "./CultureCardComponent.vue?vue&type=script&lang=js"
import style0 from "./CultureCardComponent.vue?vue&type=style&index=0&id=279458ba&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports